export default __webpack_public_path__ + "static/media/header2.2a526464.jpg";